// DashboardRouter — F9.2 WAVE 2C governed dashboard swap.
//
// When DASHBOARD_V3_ENABLED=true render <DashboardV3 />, otherwise fall
// back to the legacy <Dashboard /> component so existing users keep the
// current experience. Same pattern as LandingRootRouter.
import React from "react";
import useDashboardV3Enabled from "@/hooks/useDashboardV3Enabled";
import Dashboard from "@/pages/Dashboard";
import DashboardV3 from "@/pages/dashboard-v3/DashboardV3";
import LandingLoadingShell from "@/components/LandingLoadingShell";

export default function DashboardRouter() {
    const { loading, enabled } = useDashboardV3Enabled();
    if (loading) return <LandingLoadingShell />;
    return enabled ? <DashboardV3 /> : <Dashboard />;
}
